var render, staticRenderFns
import script from "./CustomVisualizationLayout.vue?vue&type=script&lang=js"
export * from "./CustomVisualizationLayout.vue?vue&type=script&lang=js"
import style0 from "./CustomVisualizationLayout.vue?vue&type=style&index=0&id=2ca1f8b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca1f8b8",
  null
  
)

export default component.exports